import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from './Header';
import { useTranslation } from "react-i18next";

const Logout = () => {
    return (
    <div className="wrapper">
        <Header />
        <Container className='d-flex flex-row justify-content-start flex-wrap w-100'>
            <Container className="mt-3 mb-3 w-50">
                <h3 className='mb-3'>ログアウトしました。</h3>
                <Link to="/"><Button>トップページへ</Button></Link>
            </Container>
        </Container>
    </div>
    )
}

export default Logout;
